import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";
import Swal from "sweetalert2";

export class ModOfferNegotiation extends ModuleComponent{
    ready(){
        super.ready();

        this.findMember(["accept","reject"]).click(
            (ev) => {
                ev.preventDefault();
                const prefix = $(ev.currentTarget).is(this.scope+"__accept")?"accept":"reject";
                let htmlSelect,selectName;
                if(prefix=="reject"){
                    htmlSelect = this.findMember("reject-confirm-select");
                    selectName = "selectReason";
                }else if(prefix=="accept" && this.$root.data("mode")=="tenant"){
                    htmlSelect = this.findMember("accept-confirm-privacity-check-box");
                    selectName = "privacyCheck";
                }

                if(htmlSelect && htmlSelect.length>0){
                    htmlSelect.attr("data-name",selectName);
                }

                Swal.fire({
                    title: this.$root.data(prefix+"-confirm-title"),
                    text: this.$root.data(prefix+"-confirm-text"),
                    icon: "question",
                    html: htmlSelect && htmlSelect.length>0?htmlSelect:null,
                    showCancelButton: true,
                    confirmButtonColor: prefix=="accept"?"#0A93D5":"#FC4B6C",
                    cancelButtonColor: "#333",
                    confirmButtonText: this.$root.data(prefix+"-confirm-button"),
                    cancelButtonText: this.$root.data(prefix+"-cancel-button")
                }).then((result) => {
                        if(result.isConfirmed && prefix=="accept"){
                            let privacyChecked;
                            if(this.$root.data("mode")=="tenant"){
                                privacyChecked = document.getElementsByClassName("swal2-html-container")[0].getElementsByTagName("input")[0].checked;
                            }else{
                                privacyChecked = true;
                            }
                            if(privacyChecked){
                                GvfService.endpoint("/web/offer-negotiation/accept-offer",{
                                    "offerId": this.$root.data("id"),
                                    "mode": this.$root.data("mode"),
                                    "personId": this.$root.data("pid"),
                                    "key": this.$root.data("key")
                                }).then(
                                    (resp) => {
                                        Swal.fire({
                                            title: resp.message,
                                            text: resp.description,
                                            icon: "success",
                                            confirmButtonText: "OK",
                                            didClose: () => {
                                                window.location.reload();
                                            }
                                        });
                                    }
                                );
                            }else{
                                this.findMember("accept").click();
                                Swal.showValidationMessage(
                                    "<i></i> Por favor, acepte la política de privacidad"
                                );
                            }

                        }else if(result.isConfirmed && prefix=="reject"){
                            let reason0=document.getElementsByClassName("swal2-html-container")[0].getElementsByTagName("select")[0];
                            if(reason0){
                                let reason = document.getElementsByClassName("swal2-html-container")[0].getElementsByTagName("select")[0].value;
                                let reasonOther  = document.getElementsByClassName("swal2-html-container")[0].getElementsByTagName("input")[0].value;

                                if(reason!=0){
                                    if(reason == 12 && reasonOther==""){
                                        this.findMember("reject").click();
                                        Swal.showValidationMessage(
                                            "<i></i> Por favor, especifique el razón del rechazo"
                                        );
                                        return;
                                    }
                                    GvfService.endpoint("/web/offer-negotiation/reject-offer",{
                                        "offerId": this.$root.data("id"),
                                        "mode": this.$root.data("mode"),
                                        "personId": this.$root.data("pid"),
                                        "key": this.$root.data("key"),
                                        "reasonId": reason,
                                        "reasonOther": reasonOther
                                    }).then(
                                        (resp) => {
                                            Swal.fire({
                                                title: resp.message,
                                                text: resp.description,
                                                icon: "success",
                                                confirmButtonText: "OK",
                                                didClose: () => {
                                                    window.location.reload();
                                                }
                                            });
                                        }
                                    );
                                }else{
                                    this.findMember("reject").click();
                                    Swal.showValidationMessage(
                                        "<i></i> Por favor, especifique el motivo del rechazo"
                                    );
                                }


                            }else{
                                GvfService.endpoint("/web/offer-negotiation/reject-offer",{
                                    "offerId": this.$root.data("id"),
                                    "mode": this.$root.data("mode"),
                                    "personId": this.$root.data("pid"),
                                    "key": this.$root.data("key"),
                                    "reasonId": null
                                }).then(
                                    (resp) => {
                                        Swal.fire({
                                            title: resp.message,
                                            text: resp.description,
                                            icon: "success",
                                            confirmButtonText: "OK",
                                            didClose: () => {
                                                window.location.reload();
                                            }
                                        });
                                    }
                                );
                            }


                        }
                    }
                )
                ;
            }
        )
        ;

        this.findMember(["counter"]).click(
            (ev) => {
                ev.preventDefault();
                this.findMember("counter-offer-form").slideToggle();
            }
        );

        this.findMember(["cancel-submit"]).click(
            (ev) => {
                ev.preventDefault();
                this.findMember("counter-offer-form").slideUp();
            }
        );

        this.findMember("submit").click(
            (ev) => {
                ev.preventDefault();
                const $form = this.$root.find(".js-form");
                $form.checkRestrictions().then(
                    (isOk) => {
                        if(isOk){
                            Swal.fire({
                                title: this.$root.data("counter-confirm-title"),
                                text: this.$root.data("counter-confirm-text"),
                                icon: "question",
                                showCancelButton: true,
                                confirmButtonColor: "#0A93D5",
                                cancelButtonColor: "#333",
                                confirmButtonText: this.$root.data("counter-confirm-button"),
                                cancelButtonText: this.$root.data("counter-cancel-button")
                            }).then((result) => {
                                if(result.isConfirmed){
                                    GvfService.endpoint("/web/offer-negotiation/counter-offer",{
                                        "offerId": this.$root.data("id"),
                                        "mode": this.$root.data("mode"),
                                        "personId": this.$root.data("pid"),
                                        "key": this.$root.data("key"),
                                        "formData": this.$root.find(".js-form").getValues()
                                    }).then(
                                        (resp) => {
                                            Swal.fire({
                                                title: resp.message,
                                                text: resp.description,
                                                icon: "ok",
                                                confirmButtonText: "OK",
                                                didClose: () => {
                                                    window.location.reload();
                                                }
                                            });
                                        }
                                    );
                                }
                            });
                        }
                    }
                );
            }
        );
    }
}
